import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { languageResolver } from './core/resolvers/language.resolver';

export const routes: Routes = [
    {
        path: 'configure/:serial',
        loadComponent: () =>
            import('./features/configure/configure.component').then(
                (m) => m.ConfigureComponent
            ),
        canActivate: [MsalGuard],
        resolve: { language: languageResolver },
    },
    {
        path: 'error',
        loadComponent: () =>
            import('./features/access-denied/access-denied.component').then(
                (m) => m.ErrorComponent
            ),
        canActivate: [MsalGuard],
        resolve: { language: languageResolver },
    },
    {
        path: '**',
        redirectTo: 'error'
    },
];
